import React from "react";

/* ------------------------------------------------------------------
   Themed field primitives of the scoped «.suppliers-page» design system
   (SuppliersPage.css, классы sp-*). Вынесены из SuppliersPage.jsx, чтобы
   их могли переиспользовать другие разделы (Склад, …). Поведение и
   разметка — без изменений.
   ------------------------------------------------------------------ */

export const SpInput = ({ label, value, onChange, type = "text", disabled = false, placeholder = "", span = false }) => (
    <div className={span ? "sp-fld sp-col-span" : "sp-fld"}>
        <label>{label}</label>
        <input
            className="sp-inp"
            type={type}
            value={value ?? ""}
            disabled={disabled}
            placeholder={placeholder}
            onChange={(event) => onChange && onChange(event.target.value)}
        />
    </div>
);

export const SpReadField = ({ label, value, span = false }) => (
    <div className={span ? "sp-fld sp-col-span" : "sp-fld"}>
        <label>{label}</label>
        <div className="val">{value || "—"}</div>
    </div>
);

export const SpCheck = ({ label, checked, onChange, disabled = false }) => (
    <button
        type="button"
        className={checked ? "sp-check ck" : "sp-check"}
        disabled={disabled}
        onClick={() => !disabled && onChange && onChange(!checked)}
    >
        <span className="box">{checked ? "✓" : ""}</span>
        <span>{label}</span>
    </button>
);

// Опции с полем group рендерятся в <optgroup>; без него — как обычно, порядок сохраняется.
export const groupSpOptions = (options) => {
    const blocks = [];
    options.forEach((option) => {
        const group = option.group || null;
        const last = blocks[blocks.length - 1];
        if (last && last.group === group) {
            last.items.push(option);
        } else {
            blocks.push({ group, items: [option] });
        }
    });
    return blocks;
};

export const SpSelect = ({ label, value, onChange, options, disabled = false, placeholder = "Не выбрано", span = false }) => (
    <div className={span ? "sp-fld sp-col-span" : "sp-fld"}>
        <label>{label}</label>
        <select
            className="sp-inp"
            value={value ?? ""}
            disabled={disabled}
            onChange={(event) => onChange && onChange(event.target.value)}
        >
            {placeholder != null ? <option value="">{placeholder}</option> : null}
            {groupSpOptions(options).map(({ group, items }) => {
                const rendered = items.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ));
                return group ? <optgroup key={group} label={group}>{rendered}</optgroup> : rendered;
            })}
        </select>
    </div>
);
